var _mask, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmptyLeads = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 153,
  height: 153,
  viewBox: "0 0 153 153",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 153,
  height: 153
}, /*#__PURE__*/React.createElement("circle", {
  cx: 76.5,
  cy: 76.5,
  r: 76.5,
  fill: "#F3F6F9"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 76.5,
  cy: 76.5,
  r: 76.5,
  fill: "#E9ECEF"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 41,
  y: 33,
  width: 165,
  height: 129,
  fill: "#F8F8FD"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 54,
  y: 47,
  width: 149,
  height: 15,
  rx: 2,
  fill: "white"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 66.5,
  cy: 54.5,
  r: 3.5,
  fill: "#E4E8F1"
}), /*#__PURE__*/React.createElement("rect", {
  x: 73,
  y: 54,
  width: 74,
  height: 2,
  rx: 1,
  fill: "#E4E8F1"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_d)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 54,
  y: 74,
  width: 149,
  height: 62,
  rx: 2,
  fill: "white"
})), /*#__PURE__*/React.createElement("rect", {
  x: 63,
  y: 81,
  width: 18,
  height: 2,
  rx: 1,
  fill: "#E4E8F1"
}), /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 2,
  rx: 1,
  transform: "matrix(-1 0 0 1 113 81)",
  fill: "#E4E8F1"
}), /*#__PURE__*/React.createElement("rect", {
  x: 127,
  y: 81,
  width: 18,
  height: 2,
  rx: 1,
  fill: "#E4E8F1"
}), /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 2,
  rx: 1,
  transform: "matrix(-1 0 0 1 171 81)",
  fill: "#E4E8F1"
}), /*#__PURE__*/React.createElement("rect", {
  x: 63,
  y: 97,
  width: 18,
  height: 2,
  rx: 1,
  fill: "#E4E8F1"
}), /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 2,
  rx: 1,
  transform: "matrix(-1 0 0 1 105 97)",
  fill: "#E4E8F1"
}), /*#__PURE__*/React.createElement("rect", {
  x: 127,
  y: 97,
  width: 18,
  height: 2,
  rx: 1,
  fill: "#E4E8F1"
}), /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 2,
  rx: 1,
  transform: "matrix(-1 0 0 1 177 97)",
  fill: "#E4E8F1"
}), /*#__PURE__*/React.createElement("rect", {
  x: 63,
  y: 112,
  width: 18,
  height: 2,
  rx: 1,
  fill: "#E4E8F1"
}), /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 2,
  rx: 1,
  transform: "matrix(-1 0 0 1 107 112)",
  fill: "#E4E8F1"
}), /*#__PURE__*/React.createElement("rect", {
  x: 127,
  y: 112,
  width: 18,
  height: 2,
  rx: 1,
  fill: "#E4E8F1"
}), /*#__PURE__*/React.createElement("rect", {
  width: 15,
  height: 2,
  rx: 1,
  transform: "matrix(-1 0 0 1 164 112)",
  fill: "#E4E8F1"
}), /*#__PURE__*/React.createElement("rect", {
  x: 63,
  y: 128,
  width: 18,
  height: 2,
  rx: 1,
  fill: "#E4E8F1"
}), /*#__PURE__*/React.createElement("rect", {
  width: 26,
  height: 2,
  rx: 1,
  transform: "matrix(-1 0 0 1 111 128)",
  fill: "#E4E8F1"
}), /*#__PURE__*/React.createElement("rect", {
  x: 127,
  y: 128,
  width: 18,
  height: 2,
  rx: 1,
  fill: "#E4E8F1"
}), /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 2,
  rx: 1,
  transform: "matrix(-1 0 0 1 177 128)",
  fill: "#E4E8F1"
}), /*#__PURE__*/React.createElement("line", {
  opacity: 0.5,
  x1: 54,
  y1: 89.5,
  x2: 203,
  y2: 89.5,
  stroke: "#E4E8F1"
}), /*#__PURE__*/React.createElement("line", {
  opacity: 0.5,
  x1: 54,
  y1: 105.5,
  x2: 203,
  y2: 105.5,
  stroke: "#E4E8F1"
}), /*#__PURE__*/React.createElement("line", {
  opacity: 0.5,
  x1: 54,
  y1: 121.5,
  x2: 203,
  y2: 121.5,
  stroke: "#E4E8F1"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: 37,
  y: 33,
  width: 173,
  height: 137,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.130469 0 0 0 0 0.254849 0 0 0 0 0.695833 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d",
  x: 52,
  y: 46,
  width: 153,
  height: 19,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_d",
  x: 52,
  y: 73,
  width: 153,
  height: 66,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})))));
export { SvgEmptyLeads as ReactComponent };
export default __webpack_public_path__ + "static/media/emptyLeads.f56f66cc.svg";